export enum DecisaoQuantidadeVinculoEnum {
  AceitarAjustarSaldo = 1,
  MarcarDivergencia = 2,
  DividirSaldo = 3,
}
